import { FC } from 'react'
import { LegacyImage as Image } from '@/atoms/LegacyImage'
import { MomentTypes } from '@/types/codegen-federation'

type CollectibleType = MomentTypes

interface CollectibleLogoProps {
  collectibleType: CollectibleType
  height: number
  width: number
}

export const CollectibleLogo: FC<CollectibleLogoProps> = ({ collectibleType, width, height }) => {
  return collectibleType === 'GOLDEN' ? (
    <Image
      loading="eager"
      alt="golden collectible scene logo"
      src="/v1683817411/angel-studios/collectibles/golden-collectible-badge.png"
      layout="intrinsic"
      width={width}
      height={height}
    />
  ) : (
    <Image
      loading="eager"
      alt="collectible scene logo"
      src="/v1683817411/angel-studios/collectibles/collectible-badge.png"
      layout="fixed"
      width={width}
      height={height}
    />
  )
}
